webpackJsonp([87895327789742],{

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n        width: 60px;\n        height: 60px;\n    '], ['\n        width: 60px;\n        height: 60px;\n    ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactBodymovin = __webpack_require__(68);
	
	var _reactBodymovin2 = _interopRequireDefault(_reactBodymovin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var unfavoritingAnimation = {
	    v: '5.1.1',
	    fr: 29.9700012207031,
	    ip: 0,
	    op: 78.0000031770051,
	    w: 50,
	    h: 50,
	    nm: 'Quality-Ae',
	    ddd: 0,
	    assets: [],
	    layers: [{
	        ddd: 0,
	        ind: 1,
	        ty: 4,
	        nm: 'Pencil Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: -3,
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 29, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0]],
	                        v: [[1.163, -2.924], [2.924, 2.924], [-2.924, 1.162]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [24.781, 36.886],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 3,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-7.749, -7.749], [7.749, 7.749]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [16.152, 28.256],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 2',
	            np: 3,
	            cix: 2,
	            ix: 2,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-2.043, 2.043], [2.043, -2.043]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [8.402, 20.506],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 3',
	            np: 3,
	            cix: 2,
	            ix: 3,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [-0.944, 0.943], [0, 0], [-0.944, -0.943]],
	                        o: [[0, 0], [0, 0], [-0.944, -0.944], [0, 0], [0.944, -0.943], [0, 0]],
	                        v: [[3.294, -0.793], [-0.792, 3.293], [-2.35, 1.736], [-2.35, -1.681], [-1.682, -2.35], [1.736, -2.35]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [5.602, 17.707],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 4',
	            np: 3,
	            cix: 2,
	            ix: 4,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[10.568, 6.481], [6.482, 10.567], [-10.568, -6.481], [-6.48, -10.567]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [15.376, 27.481],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 5',
	            np: 3,
	            cix: 2,
	            ix: 5,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 899.000036617021,
	        st: 0,
	        bm: 0
	    }, {
	        ddd: 0,
	        ind: 3,
	        ty: 4,
	        nm: 'Zig zag Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 1,
	                k: [{
	                    i: {
	                        x: [0.414],
	                        y: [0.983]
	                    },
	                    o: {
	                        x: [0.167],
	                        y: [0.167]
	                    },
	                    n: ['0p414_0p983_0p167_0p167'],
	                    t: 4,
	                    s: [0],
	                    e: [41]
	                }, {
	                    i: {
	                        x: [0],
	                        y: [1.437]
	                    },
	                    o: {
	                        x: [0.782],
	                        y: [0.696]
	                    },
	                    n: ['0_1p437_0p782_0p696'],
	                    t: 20,
	                    s: [41],
	                    e: [41]
	                }, {
	                    i: {
	                        x: [0.833],
	                        y: [0.833]
	                    },
	                    o: {
	                        x: [0.682],
	                        y: [0.012]
	                    },
	                    n: ['0p833_0p833_0p682_0p012'],
	                    t: 32,
	                    s: [41],
	                    e: [0]
	                }, {
	                    t: 51.0000020772726
	                }],
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [30.105, 7.202],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 2,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [27.483, 9.799],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 2',
	            np: 2,
	            cix: 2,
	            ix: 2,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [24.861, 12.397],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 3',
	            np: 2,
	            cix: 2,
	            ix: 3,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [22.238, 14.995],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 4',
	            np: 2,
	            cix: 2,
	            ix: 4,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [19.615, 17.592],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 5',
	            np: 2,
	            cix: 2,
	            ix: 5,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [16.993, 20.191],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 6',
	            np: 2,
	            cix: 2,
	            ix: 6,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [14.37, 22.788],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 7',
	            np: 2,
	            cix: 2,
	            ix: 7,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [11.748, 25.386],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 8',
	            np: 2,
	            cix: 2,
	            ix: 8,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-0.755, -0.755], [0.755, 0.755]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [9.126, 27.984],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 9',
	            np: 2,
	            cix: 2,
	            ix: 9,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0]],
	                        v: [[8.971, 8.971], [0.089, 8.971], [8.971, 0.089]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ind: 1,
	                ty: 'sh',
	                ix: 2,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0]],
	                        v: [[-15.378, 15.378], [15.378, 15.378], [15.378, -15.378]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 2',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'mm',
	                mm: 1,
	                nm: 'Merge Paths 1',
	                mn: 'ADBE Vector Filter - Merge',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [18.723, 16.877],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 10',
	            np: 5,
	            cix: 2,
	            ix: 10,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 899.000036617021,
	        st: 0,
	        bm: 0
	    }, {
	        ddd: 0,
	        ind: 5,
	        ty: 4,
	        nm: 'Lines Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[-6.182, 7.941], [6.182, -7.941]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                d: [{
	                    n: 'd',
	                    nm: 'dash',
	                    v: {
	                        a: 0,
	                        k: 0.25,
	                        ix: 1
	                    }
	                }, {
	                    n: 'g',
	                    nm: 'gap',
	                    v: {
	                        a: 0,
	                        k: 2,
	                        ix: 2
	                    }
	                }, {
	                    n: 'o',
	                    nm: 'offset',
	                    v: {
	                        a: 0,
	                        k: 0,
	                        ix: 7
	                    }
	                }],
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [40.343, 29.54],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 2,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[44.518, 40.767], [44.643, 40.767]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 2',
	            np: 2,
	            cix: 2,
	            ix: 2,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[38.225, 40.767], [43.586, 40.767]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                d: [{
	                    n: 'd',
	                    nm: 'dash',
	                    v: {
	                        a: 0,
	                        k: 0.233,
	                        ix: 1
	                    }
	                }, {
	                    n: 'g',
	                    nm: 'gap',
	                    v: {
	                        a: 0,
	                        k: 1.865,
	                        ix: 2
	                    }
	                }, {
	                    n: 'o',
	                    nm: 'offset',
	                    v: {
	                        a: 0,
	                        k: 0,
	                        ix: 7
	                    }
	                }],
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 3',
	            np: 2,
	            cix: 2,
	            ix: 3,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[36.235, 40.767], [36.36, 40.767]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 4',
	            np: 2,
	            cix: 2,
	            ix: 4,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -3.951], [3.951, 0], [0, 3.952], [-3.952, 0]],
	                        o: [[0, 3.952], [-3.952, 0], [0, -3.951], [3.951, 0]],
	                        v: [[7.155, 0], [0.001, 7.155], [-7.155, 0], [0.001, -7.155]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [39.412, 30.73],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 5',
	            np: 3,
	            cix: 2,
	            ix: 5,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -1.051], [1.05, 0], [0, 1.051], [-1.051, 0]],
	                        o: [[0, 1.051], [-1.051, 0], [0, -1.051], [1.05, 0]],
	                        v: [[1.902, 0], [0.001, 1.902], [-1.902, 0], [0.001, -1.902]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [32.258, 40.466],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 6',
	            np: 3,
	            cix: 2,
	            ix: 6,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0]],
	                        v: [[3.439, 3.439], [-3.439, 3.439], [-3.439, -3.439]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [45.012, 15.998],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 7',
	            np: 3,
	            cix: 2,
	            ix: 7,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[-14.499, -17.171], [7.473, -17.171], [14.499, -10.294], [14.499, 17.171], [-14.499, 17.171]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [34.1, 29.731],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 8',
	            np: 3,
	            cix: 2,
	            ix: 8,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -11.907], [11.907, 0], [0, 11.907], [-11.907, 0]],
	                        o: [[0, 11.907], [-11.907, 0], [0, -11.907], [11.907, 0]],
	                        v: [[21.559, 0], [0.001, 21.559], [-21.559, 0], [0.001, -21.559]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0.902000038297, 0.902000038297, 0.902000038297, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [25.071, 25.898],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 9',
	            np: 2,
	            cix: 2,
	            ix: 9,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 899.000036617021,
	        st: 0,
	        bm: 0
	    }],
	    markers: []
	};
	
	
	var QualityIcon = function QualityIcon(_ref) {
	    var autoplay = _ref.autoplay;
	
	
	    var QualityIconContainer = _styledComponents2.default.div(_templateObject);
	
	    var bodymovinOptions = {
	        loop: true,
	        autoplay: { autoplay: autoplay },
	        prerender: true,
	        animationData: unfavoritingAnimation
	    };
	
	    return _react2.default.createElement(
	        QualityIconContainer,
	        null,
	        _react2.default.createElement(_reactBodymovin2.default, { options: bodymovinOptions })
	    );
	};
	
	exports.default = QualityIcon;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Heading = __webpack_require__(44);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Form = __webpack_require__(52);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _SubpageBodyStyles = __webpack_require__(55);
	
	var _LandingHeader = __webpack_require__(24);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var relativePath = ("/pages/have-it-made/");
	
	var SubpageBody = function SubpageBody(_ref) {
	    var children = _ref.children,
	        headerText = _ref.headerText,
	        subHeaderText = _ref.subHeaderText,
	        category = _ref.category,
	        formHeading = _ref.formHeading,
	        backgroundImages = _ref.backgroundImages;
	
	
	    var redirectOnSubmit = function redirectOnSubmit(state) {
	        var redirectRelativePath = headerText.toLowerCase();
	        if (state.isLeadForm) {
	            window.location.href = '' + relativePath + redirectRelativePath + '/thank-you?zip=' + state.values.zip;
	        } else {
	            window.location.href = '' + relativePath + redirectRelativePath + '/thanks';
	        }
	    };
	
	    return _react2.default.createElement(
	        _SubpageBodyStyles.SubpageBodyContainer,
	        {
	            backgroundImages: backgroundImages },
	        _react2.default.createElement(
	            'div',
	            { className: 'header-overlay' },
	            _react2.default.createElement('div', { className: 'header-overlay-filter' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'subpage-column-left' },
	            _react2.default.createElement(
	                'span',
	                { className: 'subpage-header' },
	                _react2.default.createElement(
	                    _Heading2.default,
	                    {
	                        headingSize: 'xxlarge',
	                        headingTag: 'h1',
	                        headingColor: _colors2.default.wsWhite },
	                    headerText
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'subpage-content' },
	                _react2.default.createElement(
	                    _Heading2.default,
	                    {
	                        headingSize: 'xlarge',
	                        headingTag: 'h2',
	                        headingColor: _colors2.default.grayscaleCoolGray11 },
	                    subHeaderText
	                ),
	                _react2.default.createElement(
	                    _SubpageBodyStyles.BodyCopyContainer,
	                    null,
	                    children
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'subpage-column-right' },
	            _react2.default.createElement(_Form2.default, { formTypes: { originWebApp: 'clayton-homes-website', originWebPageType: 'him-campaign-landing-page', originCampaign: 'him-2018', originWebFormCategory: category },
	                options: { formHeading: formHeading, redirect: redirectOnSubmit } })
	        )
	    );
	};
	
	exports.default = SubpageBody;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BodyCopyContainer = exports.SubpageBodyContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        display: table;\n        max-width: 1750px;\n        padding-left: 11.2%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 170px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 17px;\n            padding-top: 268px;\n            width: 483px;\n        }\n\n        .subpage-content {\n            padding-top: 35px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n        }\n        \n        .react-bodymovin-container {\n            height: 50px;\n            width: 50px;\n        }\n\n        h2 {\n            line-height: 1.14;\n            margin-bottom: 25px;\n        }\n\n        h3 {\n            font-size: 22px;\n            margin: 0;\n        }\n    }\n\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  \n        .movin-header svg {\n            height: 60px !important;\n            width: 60px !important;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        display: table;\n        padding-left: 5.4%;\n        width: 100%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 188px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 29px;\n            padding-top: 268px;\n            width: 375px;\n        }\n\n        .subpage-content {\n            padding-top: 44px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 32px;\n                letter-spacing: -.8px;\n            }\n\n            \n            h2 {\n                font-size: 30px;\n                letter-spacing: -2px;\n                line-height: 1;\n                margin-left: -5px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 60px;\n            width: 60px;\n        }\n\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        display: block;\n        padding-left: 15px;\n        width: 100%;\n\n        .subpage-column-left {\n            display: block;\n            padding-top: 202px\n        }\n\n        .subpage-column-right {\n            display: block;\n            padding-left: 0;\n            padding-right: 18px;\n            padding-top: 20px;\n            width: 100%;\n        }\n\n        .subpage-content {\n            padding-top: 30px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 33px;\n                letter-spacing: -.9px;\n            }\n\n            h2 {\n                font-size: 27px;\n                letter-spacing: -.5px;\n                line-height: 1.1;\n                margin-left: 0px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 65px;\n            width: 65px;\n        }\n\n    }\n'], ['\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        display: table;\n        max-width: 1750px;\n        padding-left: 11.2%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 170px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 17px;\n            padding-top: 268px;\n            width: 483px;\n        }\n\n        .subpage-content {\n            padding-top: 35px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n        }\n        \n        .react-bodymovin-container {\n            height: 50px;\n            width: 50px;\n        }\n\n        h2 {\n            line-height: 1.14;\n            margin-bottom: 25px;\n        }\n\n        h3 {\n            font-size: 22px;\n            margin: 0;\n        }\n    }\n\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  \n        .movin-header svg {\n            height: 60px !important;\n            width: 60px !important;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        display: table;\n        padding-left: 5.4%;\n        width: 100%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 188px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 29px;\n            padding-top: 268px;\n            width: 375px;\n        }\n\n        .subpage-content {\n            padding-top: 44px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 32px;\n                letter-spacing: -.8px;\n            }\n\n            \n            h2 {\n                font-size: 30px;\n                letter-spacing: -2px;\n                line-height: 1;\n                margin-left: -5px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 60px;\n            width: 60px;\n        }\n\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        display: block;\n        padding-left: 15px;\n        width: 100%;\n\n        .subpage-column-left {\n            display: block;\n            padding-top: 202px\n        }\n\n        .subpage-column-right {\n            display: block;\n            padding-left: 0;\n            padding-right: 18px;\n            padding-top: 20px;\n            width: 100%;\n        }\n\n        .subpage-content {\n            padding-top: 30px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 33px;\n                letter-spacing: -.9px;\n            }\n\n            h2 {\n                font-size: 27px;\n                letter-spacing: -.5px;\n                line-height: 1.1;\n                margin-left: 0px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 65px;\n            width: 65px;\n        }\n\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    color: ', ';\n    font-family: "source-sans-pro", sans-serif;\n    font-size: 16px;\n    line-height: 27px;\n'], ['\n    color: ', ';\n    font-family: "source-sans-pro", sans-serif;\n    font-size: 16px;\n    line-height: 27px;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageBodyContainer = exports.SubpageBodyContainer = _styledComponents2.default.div(_templateObject, _LandingPageStyles2.default.viewBreakpoints.desktop, _LandingPageStyles2.default.viewBreakpoints.tablet, _LandingPageStyles2.default.viewBreakpoints.mobile);
	
	var BodyCopyContainer = exports.BodyCopyContainer = _styledComponents2.default.div(_templateObject2, _colors2.default.grayscaleCoolGray08);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _CircleArrow = __webpack_require__(76);
	
	var _CircleArrow2 = _interopRequireDefault(_CircleArrow);
	
	var _SubpageFooterStyles = __webpack_require__(57);
	
	var _LandingFooter = __webpack_require__(53);
	
	var _LandingFooter2 = _interopRequireDefault(_LandingFooter);
	
	var _urlTools = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubpageFooter = function SubpageFooter(_ref) {
	    var linkNext = _ref.linkNext,
	        linkPrev = _ref.linkPrev,
	        textNext = _ref.textNext,
	        textPrev = _ref.textPrev;
	
	    return _react2.default.createElement(
	        _SubpageFooterStyles.SubpageFooterContainer,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'footer-nav' },
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-left' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: (0, _urlTools.getLinkWithQueryString)(linkPrev) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'standard-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 1)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hover-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 0)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'nav-text' },
	                        textPrev
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-right' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: (0, _urlTools.getLinkWithQueryString)(linkNext) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'nav-text' },
	                        textNext
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'standard-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 1)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hover-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 0)', circleDiameter: '33' })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_LandingFooter2.default, null)
	    );
	};
	
	exports.default = SubpageFooter;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SubpageFooterContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-top: 57px;\n\n    .footer-nav {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        max-width: 100%;\n    }\n    \n    .nav-text {\n        color: ', ';\n        font-family: \'acumin-pro\', sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 1.28;\n        letter-spacing: normal;\n        position: absolute;\n        top: 32%;\n        transform: translateY(-50%);\n    }\n    .footer-left {\n        position: relative;\n        width: 50%;\n\n        .nav-text {\n            left: 45px;\n        }\n        .circle-arrow {\n            transform: rotate(180deg);\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .footer-right {\n        position: relative;\n        text-align: right;\n        width: 50%;\n\n        .nav-text {\n            right: 45px;\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .circle-arrow {\n        display: inline-block;\n        margin-bottom: 12px;\n        max-width: 64px;\n    }\n\n    .footer-container {\n        color: ', ';\n        position: relative;\n\n        a {\n            color: ', ';\n\n            &:hover {\n                color: ', ';\n            }\n        }\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 1.58%;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 4%;\n        }\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        margin-top: 0;\n\n        .footer-nav {\n            margin: auto;\n            width: 80%;\n        }\n\n        .footer-right,\n        .footer-left {\n            a:hover {\n                .hover-state {\n                    display: none;\n                }\n                .standard-state {\n                    display: inline-block;\n                }\n            }\n        }\n    }\n'], ['\n    margin-top: 57px;\n\n    .footer-nav {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        max-width: 100%;\n    }\n    \n    .nav-text {\n        color: ', ';\n        font-family: \'acumin-pro\', sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 1.28;\n        letter-spacing: normal;\n        position: absolute;\n        top: 32%;\n        transform: translateY(-50%);\n    }\n    .footer-left {\n        position: relative;\n        width: 50%;\n\n        .nav-text {\n            left: 45px;\n        }\n        .circle-arrow {\n            transform: rotate(180deg);\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .footer-right {\n        position: relative;\n        text-align: right;\n        width: 50%;\n\n        .nav-text {\n            right: 45px;\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .circle-arrow {\n        display: inline-block;\n        margin-bottom: 12px;\n        max-width: 64px;\n    }\n\n    .footer-container {\n        color: ', ';\n        position: relative;\n\n        a {\n            color: ', ';\n\n            &:hover {\n                color: ', ';\n            }\n        }\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 1.58%;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 4%;\n        }\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        margin-top: 0;\n\n        .footer-nav {\n            margin: auto;\n            width: 80%;\n        }\n\n        .footer-right,\n        .footer-left {\n            a:hover {\n                .hover-state {\n                    display: none;\n                }\n                .standard-state {\n                    display: inline-block;\n                }\n            }\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageFooterContainer = exports.SubpageFooterContainer = _styledComponents2.default.div(_templateObject, _colors2.default.grayscaleCoolGray11, _colors2.default.grayscaleCoolGray06, _colors2.default.grayscaleCoolGray06, _colors2.default.grayscaleCoolGray08, _LandingPageStyles2.default.viewBreakpoints.desktop, _LandingPageStyles2.default.viewBreakpoints.tablet, _LandingPageStyles2.default.viewBreakpoints.mobile);

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-quality-header.a6b74870.jpg";

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-quality-mobile.9a010e79.jpg";

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-quality-tablet.e25b56b1.jpg";

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QualityIcon = __webpack_require__(478);
	
	var _QualityIcon2 = _interopRequireDefault(_QualityIcon);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _utils = __webpack_require__(45);
	
	var _LandingHeader = __webpack_require__(24);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	__webpack_require__(94);
	
	var _SubpageStyles = __webpack_require__(58);
	
	var _SubpageStyles2 = _interopRequireDefault(_SubpageStyles);
	
	var _SubpageBody = __webpack_require__(54);
	
	var _SubpageBody2 = _interopRequireDefault(_SubpageBody);
	
	var _SubpageFooter = __webpack_require__(56);
	
	var _SubpageFooter2 = _interopRequireDefault(_SubpageFooter);
	
	var _Analytics = __webpack_require__(18);
	
	var _ScriptTags = __webpack_require__(28);
	
	var _ScriptTags2 = _interopRequireDefault(_ScriptTags);
	
	var _ImageSets = __webpack_require__(77);
	
	var _ImageSets2 = _interopRequireDefault(_ImageSets);
	
	var _subpagesQualityMobile = __webpack_require__(597);
	
	var _subpagesQualityMobile2 = _interopRequireDefault(_subpagesQualityMobile);
	
	var _subpagesQualityTablet = __webpack_require__(600);
	
	var _subpagesQualityTablet2 = _interopRequireDefault(_subpagesQualityTablet);
	
	var _subpagesQualityHeader = __webpack_require__(589);
	
	var _subpagesQualityHeader2 = _interopRequireDefault(_subpagesQualityHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quality = function Quality(props) {
	
	    // save any utm params to local session cache
	    if (props.location && props.location.search) {
	        (0, _utils.saveUTMSessionParams)(props.location.search);
	    }
	
	    var backgroundImages = new _ImageSets2.default(_subpagesQualityMobile2.default, _subpagesQualityTablet2.default, _subpagesQualityHeader2.default);
	
	    return _react2.default.createElement(
	        _SubpageStyles2.default,
	        { backgroundImages: backgroundImages },
	        _react2.default.createElement(_LandingHeader2.default, null),
	        _react2.default.createElement(
	            _SubpageBody2.default,
	            {
	                category: 'quality',
	                headerText: 'Quality',
	                subHeaderText: 'Clayton Built\xAE Homes: Quality You Can Trust',
	                formHeading: 'Don\'t take our word for it, though.' },
	            _react2.default.createElement(
	                'div',
	                { className: 'movin-header' },
	                _react2.default.createElement(_QualityIcon2.default, null),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Don\'t settle for less.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'body-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body-column-left' },
	                    'The quality of a home is in more than just brand name materials and modern, efficient features. Smart construction helps trained craftsmen build manufactured and modular homes that are strong and durable.  Our streamlined home building process means that homes can be constructed off-site in climate controlled building facilities in significantly less time than most traditional home builds.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body-column-right' },
	                    'And, Clayton Built\xAE homes are all constructed to high standards of strength and durability under the watchful gaze of internal inspectors, so you can rest assured that the home you choose will stand up to a lifetime of baby\u2019s firsts, birthday parties, puppy paws and Mother Nature.'
	                )
	            )
	        ),
	        _react2.default.createElement(_SubpageFooter2.default, {
	            linkNext: '/style',
	            linkPrev: '/affordability',
	            textNext: 'Style',
	            textPrev: 'Affordability'
	        }),
	        _react2.default.createElement(_ScriptTags2.default, null),
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            {
	                onChangeClientState: _Analytics.onHelmetChangeClientState,
	                script: [{
	                    type: 'text/javascript',
	                    innerHTML: '\n                    if (typeof fbq !== \'undefined\'){\n                        fbq(\'track\', \'PageView\');\n                    }\n                    if (typeof gtag !== \'undefined\'){\n                        gtag(\'event\', \'page_view\', {\'send_to\': \'AW-1040796449\',\'dynx_itemid\': \'HIM2018\',\'dynx_pagetype\': \'Quality\'});\n                        gtag(\'event\', \'conversion\', {\n                            \'allow_custom_scripts\': true,\n                            \'send_to\': \'DC-6346097/fall1003/fall10+standard\'\n                        });\n                    }\n                '
	                }]
	            },
	            _react2.default.createElement(
	                'title',
	                null,
	                'Have It Made | Quality | Clayton Homes'
	            )
	        )
	    );
	};
	
	exports.default = Quality;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-position: center top;\n    color: ', ';\n    display: block;\n    font-family: \'acumin-pro\', sans-serif;\n    \n    width: 100%;\n\n    .header-overlay {\n        background-repeat: no-repeat;\n        left: 0;\n        position: absolute;\n        top: 0;\n        z-index: ', ';\n        width: 100%;\n    }\n\n    .header-overlay-filter {\n        background-color: ', ';\n        height: 100%;\n        width: 100%;\n    }\n\n    @media screen and (', '){\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        display: table;\n\n        .movin-header {\n            margin-top: -2px;\n\n            & > div, & > h3 {\n                display: inline-block;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 4px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: table;\n            letter-spacing: -.35px;\n            margin-top: 2px;\n            padding-top: 15px;\n            width: 86%;\n        }\n        \n        .body-column-left {\n            display: table-cell;\n            width: 50%\n        }\n\n         .body-column-right {\n            display: table-cell;\n            padding-left: 25px;\n            width: 50%\n         }\n\n    }\n\n    \n    @media screen and (min-width: 1501px) {\n        .header-overlay {\n            background-size: 100% auto;\n        }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -8px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 10px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.30px;\n            margin-left: -3px;\n            margin-top: 16px;\n            padding-top: 24px;\n            width: 99%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n         .body-column-right {\n            display: block;\n            padding-left: 0;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: 100% auto;\n            height: 270px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -12px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                letter-spacing: -.1px;\n                line-height: 1.4;\n                padding-left: 12px;\n                padding-right: 20px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.33px;\n            line-height: 1.7;\n            margin-left: -1px;\n            margin-top: 7px;\n            padding-right: 15px;\n            padding-top: 20px;\n            width: 100%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n        .body-column-right {\n            display: block;\n            padding-left: 0px;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (max-width: 392px) {\n        .header-overlay {\n            background-size: auto 100%;\n        }\n    }\n'], ['\n    background-position: center top;\n    color: ', ';\n    display: block;\n    font-family: \'acumin-pro\', sans-serif;\n    \n    width: 100%;\n\n    .header-overlay {\n        background-repeat: no-repeat;\n        left: 0;\n        position: absolute;\n        top: 0;\n        z-index: ', ';\n        width: 100%;\n    }\n\n    .header-overlay-filter {\n        background-color: ', ';\n        height: 100%;\n        width: 100%;\n    }\n\n    @media screen and (', '){\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        display: table;\n\n        .movin-header {\n            margin-top: -2px;\n\n            & > div, & > h3 {\n                display: inline-block;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 4px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: table;\n            letter-spacing: -.35px;\n            margin-top: 2px;\n            padding-top: 15px;\n            width: 86%;\n        }\n        \n        .body-column-left {\n            display: table-cell;\n            width: 50%\n        }\n\n         .body-column-right {\n            display: table-cell;\n            padding-left: 25px;\n            width: 50%\n         }\n\n    }\n\n    \n    @media screen and (min-width: 1501px) {\n        .header-overlay {\n            background-size: 100% auto;\n        }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -8px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 10px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.30px;\n            margin-left: -3px;\n            margin-top: 16px;\n            padding-top: 24px;\n            width: 99%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n         .body-column-right {\n            display: block;\n            padding-left: 0;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: 100% auto;\n            height: 270px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -12px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                letter-spacing: -.1px;\n                line-height: 1.4;\n                padding-left: 12px;\n                padding-right: 20px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.33px;\n            line-height: 1.7;\n            margin-left: -1px;\n            margin-top: 7px;\n            padding-right: 15px;\n            padding-top: 20px;\n            width: 100%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n        .body-column-right {\n            display: block;\n            padding-left: 0px;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (max-width: 392px) {\n        .header-overlay {\n            background-size: auto 100%;\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageContainer = _styledComponents2.default.div(_templateObject, _colors2.default.grayscaleCoolGray11, _LandingPageStyles2.default.zIndices.headerOverlay, _LandingPageStyles2.default.grayFilter, _LandingPageStyles2.default.viewBreakpoints.desktop, function (props) {
	    return props.backgroundImages.desktopImage;
	}, _LandingPageStyles2.default.viewBreakpoints.tablet, function (props) {
	    return props.backgroundImages.tabletImage;
	}, _LandingPageStyles2.default.viewBreakpoints.mobile, function (props) {
	    return props.backgroundImages.mobileImage;
	});
	
	exports.default = SubpageContainer;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quality-js-beec9e3efcccd659ee33.js